import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.NonWarrantyPricePoint.Save.IRequest;
type Response = Api.Core.NonWarrantyPricePoint.Save.IResponse;
type Headers = Api.Core.NonWarrantyPricePoint.Save.IHeaders;
const url = '/api/ProductManagement/NonWarrantyPricePoint';
export default async function nonWarrantyPricePointSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
